module.exports = __webpack_public_path__ + "static/assets/b395342091ad731257aeee0d6d03d19a.png";